import { render, staticRenderFns } from "./EarnedPointsBlock.vue?vue&type=template&id=59afb630&scoped=true&"
import script from "./EarnedPointsBlock.vue?vue&type=script&lang=js&"
export * from "./EarnedPointsBlock.vue?vue&type=script&lang=js&"
import style0 from "./EarnedPointsBlock.vue?vue&type=style&index=0&id=59afb630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59afb630",
  null
  
)

export default component.exports